export default __webpack_public_path__ + "assets/images/3.a64803.webp";